"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewMoreLinkContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ViewMoreLinkContainer = styled_1.default.div `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
`;
//# sourceMappingURL=styles.js.map